module.exports = __webpack_public_path__ + "img/scene-0.f814ec34.png";